import { configureStore } from "@reduxjs/toolkit";

import postReducer from "./slices/postSlice";
import clientReducer from "./slices/clientSlice";
import contactReducer from "./slices/contactSlice";
import clientFollowReducer from "./slices/clientFollowSlice";
import donationReducer from "./slices/donationSlice";
import postViewReducer from "./slices/postViewSlice";
import advertisementReducer from "./slices/advertisementSlice";
import clubReducer from "./slices/clubSlice";
import publicAuthReducer from "./slices/publicAuthSlice";
import groupReducer from "./slices/groupSlice";
import matrimonyReducer from "./slices/materimonySlice";
import clubSectionReducer from "./slices/clubSectionSlice";
import connectionReducer from "./slices/connectionSlice";
import professionReducer from "./slices/professionSlice";

import eventReducer from "./slices/eventSlice";

export const store = configureStore({
  reducer: {
    posts: postReducer,
    client: clientReducer,
    contact: contactReducer,
    clientFollow: clientFollowReducer,
    donation: donationReducer,
    postView: postViewReducer,
    advertisements: advertisementReducer,
    club: clubReducer,
    publicAuth: publicAuthReducer,
    group: groupReducer,
    matrimony: matrimonyReducer,
    clubSection: clubSectionReducer,
    connections: connectionReducer,
    profession: professionReducer,

    event: eventReducer,
  },
});

export type RootState =
  ReturnType<
    typeof store.getState
  >;

export type AppDispatch =
  typeof store.dispatch;